export default __webpack_public_path__ + "static/media/google-g-2015.6782ab74.svg";